/* eslint-disable max-lines-per-function */
import { DetailsContentsWrapper } from 'pages/details/details-contents-wrapper';
import {
  DetailsPageWrapper,
  DetailsSectionSkeletonWrapper,
  DetailsSkeleton,
  DetailsSkeletonCol,
  DetailsSkeletonWrapper,
  IconSkeletonCol,
} from 'pages/details/styles';
import { DetailsSkeletonVariants } from 'pages/details/utils';
import { MetadataFlags } from 'shared/consts/metadata-flags-enum';
import { useFieldMetadata } from 'hooks/use-ui-metadata.hook';

export const DetailsPageLoader = (): JSX.Element => {
  const isExternalIdEnabled = useFieldMetadata(MetadataFlags.EXTERNAL_ID_ENABLED);

  return (
    <DetailsPageWrapper className="details-page-wrapper">
      <DetailsSkeletonWrapper data-testid="details-page-skeleton">
        <DetailsSkeleton variant={DetailsSkeletonVariants.TITLE} />
        <DetailsSkeleton variant={DetailsSkeletonVariants.SUBTITLE} />
        <DetailsContentsWrapper>
          <DetailsSkeleton variant={DetailsSkeletonVariants.SECTION} />
          {isExternalIdEnabled && (
            <DetailsSectionSkeletonWrapper data-testid="order-number-skeleton">
              <IconSkeletonCol>
                <DetailsSkeleton variant={DetailsSkeletonVariants.ICON} />
              </IconSkeletonCol>
              <DetailsSkeletonCol>
                <DetailsSkeleton variant={DetailsSkeletonVariants.MEDIUM_DETAILS} />
                <DetailsSkeleton variant={DetailsSkeletonVariants.SHORT_DETAILS} />
              </DetailsSkeletonCol>
            </DetailsSectionSkeletonWrapper>
          )}
          <DetailsSectionSkeletonWrapper>
            <IconSkeletonCol>
              <DetailsSkeleton variant={DetailsSkeletonVariants.ICON} />
            </IconSkeletonCol>
            <DetailsSkeletonCol>
              <DetailsSkeleton variant={DetailsSkeletonVariants.LONG_DETAILS} />
              <DetailsSkeleton variant={DetailsSkeletonVariants.MEDIUM_DETAILS} />
              <DetailsSkeleton variant={DetailsSkeletonVariants.SHORT_DETAILS} />
            </DetailsSkeletonCol>
          </DetailsSectionSkeletonWrapper>
          <DetailsSectionSkeletonWrapper>
            <IconSkeletonCol>
              <DetailsSkeleton variant={DetailsSkeletonVariants.ICON} />
            </IconSkeletonCol>
            <DetailsSkeletonCol>
              <DetailsSkeleton variant={DetailsSkeletonVariants.MEDIUM_DETAILS} />
              <DetailsSkeleton variant={DetailsSkeletonVariants.SHORT_DETAILS} />
            </DetailsSkeletonCol>
          </DetailsSectionSkeletonWrapper>
        </DetailsContentsWrapper>
      </DetailsSkeletonWrapper>
    </DetailsPageWrapper>
  );
};
